import React, { useContext, useEffect } from "react";
import Hero from "../../Components/Businesses/Yarn/Hero";
import Tutorials from "../../Components/Businesses/Yarn/Tutorials";
import { AppContext } from "../../Contexts/AppContext";

const YarnHeaven = () => {
  const context = useContext(AppContext);
  useEffect(() => {
    localStorage.setItem("current", "business");
    context.setCurrent("business");
  }, [context]);
  return (
    <div>
      <Hero />
      <Tutorials />
    </div>
  );
};

export default YarnHeaven;
